import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = s((t, r) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: r,
    ...t,
    image: (e) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M8.375 0C5.169 0 2 2.138 2 5.597c0 2.2 1.237 3.45 1.987 3.45.31 0 .488-.863.488-1.106 0-.291-.74-.91-.74-2.12 0-2.512 1.912-4.293 4.387-4.293 2.128 0 3.703 1.21 3.703 3.431 0 1.66-.666 4.772-2.822 4.772-.778 0-1.444-.562-1.444-1.368 0-1.182.825-2.325.825-3.544 0-2.069-2.934-1.694-2.934.806 0 .525.066 1.106.3 1.584-.431 1.857-1.312 4.622-1.312 6.535 0 .59.084 1.172.14 1.762.106.119.053.107.216.047 1.575-2.156 1.519-2.578 2.231-5.4.384.731 1.378 1.125 2.166 1.125 3.318 0 4.809-3.234 4.809-6.15C14 2.025 11.319 0 8.375 0"
          }
        )
      }
    )
  }
));
n.displayName = "PinterestIcon";
export {
  n as PinterestIcon,
  n as default
};
//# sourceMappingURL=index.js.map
